import React from 'react'

const DoctorsBody = () => {
    return (
        <div className="doctors bg-red-100 flex-1">
            
        </div>
    )
}

export default DoctorsBody
